module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMS45NTFWMGgyMHYxLjk1MUgwWm0wIDQuNjgzVjQuNjgzaDIwdjEuOTUxSDBabTAgNC42ODNWOS4zNjZoMjB2MS45NTFIMFpNMCAxNnYtMS45NTFoMjBWMTZIMFoiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/home-menu.svg
// module id = TvSp
// module chunks = 41